import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_RIGHT__24} from '@homeaway/svg-defs';
import './DateRangeDisplay.less';
import DateDisplay from '../DateDisplay/DateDisplay';

const dateRangeDisplayClassName = 'date-range-display';
const dateRangeDisplayDateClassName = `${dateRangeDisplayClassName}-date`;
const dateRangeDisplayStartDateClassName = `${dateRangeDisplayDateClassName}--start`;
const dateRangeDisplayEndDateClassName = `${dateRangeDisplayDateClassName}--end`;
const dateRangeDisplaySeparatorClassName = `${dateRangeDisplayClassName}-separator`;

const startDateClassName = classNames(
    dateRangeDisplayDateClassName,
    dateRangeDisplayStartDateClassName
);
const endDateClassName = classNames(
    dateRangeDisplayDateClassName,
    dateRangeDisplayEndDateClassName
);

const iconClassName = classNames('icon', 'icon--large', 'icon--arrow-down');
const largeIconClassName = 'large-icon';

const DateRangeDisplay = ({
    locale,
    startLabel,
    endLabel,
    startDate,
    endDate,
    isSelecting,
    dateFormatOptions,
}) => {
    const isFilled = startDate && endDate;

    const isStartActive = !isFilled && !isSelecting;
    const isEndActive = !isFilled && isSelecting;

    return (
        <div className={dateRangeDisplayClassName}>
            <div className={startDateClassName}>
                <DateDisplay
                    locale={locale}
                    label={startLabel}
                    date={startDate}
                    dateFormatOptions={dateFormatOptions}
                    isActive={isStartActive}
                />
            </div>
            <div className={dateRangeDisplaySeparatorClassName}>
                <span className={iconClassName}>
                    <SVGIcon
                        className={largeIconClassName}
                        markup={ARROW_RIGHT__24}
                    />
                </span>
            </div>
            <div className={endDateClassName}>
                <DateDisplay
                    locale={locale}
                    label={endLabel}
                    date={endDate}
                    dateFormatOptions={dateFormatOptions}
                    isActive={isEndActive}
                />
            </div>
        </div>
    );
};

DateRangeDisplay.propTypes = {
    locale: PropTypes.string,
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    dateFormatOptions: PropTypes.objectOf(PropTypes.string),
    isSelecting: PropTypes.bool,
};

DateRangeDisplay.defaultProps = {};

export default DateRangeDisplay;
